import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Learner.css";
import EnhancedToolbar from '../../widgets/Toolbar';
import ViewUtils from '../../ViewUtils';
import { EntityForm } from '../../widgets/Forms';
import { SelectItem } from '../../widgets/SelectItem';
import { LearnerLearnershipForm } from '../program/registration/LearnerLearnershipForm';
import { LearnerSkillsProgramForm } from '../program/registration/LearnerSkillsProgramForm';
import { LearnerUnitStandardForm } from '../program/registration/LearnerUnitStandardForm';
import { LearnerQualificationForm } from '../program/registration/LearnerQualificationForm';
import { LearnerTradeForm } from "../program/registration/LearnerTradeForm";
import { LearnerInternshipForm } from "../program/registration/LearnerInternshipForm";
import { LearnerBursaryForm } from "../program/registration/LearnerBursaryForm";
import { LearnerAETForm } from "../program/registration/LearnerAETForm";
import { LearnerFETForm } from "../program/registration/LearnerFETForm";
import { LearnerCandidacyForm } from "../program/registration/LearnerCandidacyForm";

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to Search', theme: true },
                { id: 'finish', label: 'FINISH', tooltip: 'Save and Finish Process', theme: true }
            ]
        }
    ]
};

const learnershipFormRef = React.createRef();
const skillsProgramFormRef = React.createRef();
const unitStandardFormRef = React.createRef();
const qualificationFormRef = React.createRef();

const tradeFormRef = React.createRef();
const internshipFormRef = React.createRef();
const bursaryFormRef = React.createRef();
const aetFormRef = React.createRef();
const fetFormRef = React.createRef();
const candidacyFormRef = React.createRef();

const utils = new ViewUtils();

class AddLearnerProgram extends Component {

    state = {
        model: {},
        searchParameters: null,
        message: "",
        dependency: null,
        formValue: { Intervension: null },
        selection: {},
        selectedIntervension: null
    };

    handleFormValueChange(values) {
        this.setState({ model: values });
    }

    handleBursaryFormValueChange = (values) => {

        if (!utils.isNull(values)) {
            if (!utils.isNull(values.BursaryTypeID) && JSON.stringify(this.state.dependency) !== JSON.stringify(values.BursaryTypeID)) {
                const bursaryTypeID = {
                    Name: "BursaryTypeID",
                    Value: values.BursaryTypeID.Id
                }
                if (!utils.isNull(bursaryTypeID.Value)) {
                    this.setState({ dependency: bursaryTypeID })
                }
            };
            this.setState({ model: values });
        }
    }

    handleInternshipFormValueChange = (values) => {

        if (!utils.isNull(values)) {
            if (!utils.isNull(values.InternshipStartDate)) {
                if (values.InternshipTypeID.Description.includes("12")) {
                    utils.autoSetDate(this, internshipFormRef, values.InternshipStartDate, 1, 0, 0, "EndDate", "InternshipStartDate")
                }
                else if (values.InternshipTypeID.Description.includes("6")) {
                    utils.autoSetDate(this, internshipFormRef, values.InternshipStartDate, 0, 6, 0, "EndDate", "InternshipStartDate")
                }
            }
            this.setState({ model: values });
        }
    }

    handleProgrammeFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ selectedIntervension: values.Intervension });
        }
    }

    handleToolbarButtonClick(buttonId) {

        if ("back" === buttonId) {
            this.props.stepHandler(3, false, this.state.model);
        } else if ("finish" === buttonId) {
            let formValue = null;

            if (!utils.isNull(this.state.selectedIntervension)) {
                if ((1 == this.state.selectedIntervension.Id)) {
                    formValue = learnershipFormRef.current.getValue();
                } else if ((2 == this.state.selectedIntervension.Id)) {
                    formValue = skillsProgramFormRef.current.getValue();
                } else if ((3 == this.state.selectedIntervension.Id)) {
                    formValue = unitStandardFormRef.current.getValue();
                } else if ((4 == this.state.selectedIntervension.Id)) {
                    formValue = qualificationFormRef.current.getValue();
                } else if ((5 == this.state.selectedIntervension.Id)) {
                    formValue = tradeFormRef.current.getValue();
                } else if ((6 == this.state.selectedIntervension.Id)) {
                    formValue = internshipFormRef.current.getValue();
                } else if ((7 == this.state.selectedIntervension.Id)) {
                    formValue = bursaryFormRef.current.getValue();
                } else if ((8 == this.state.selectedIntervension.Id)) {
                    formValue = aetFormRef.current.getValue();
                } else if ((9 == this.state.selectedIntervension.Id)) {
                    formValue = fetFormRef.current.getValue();
                } else if ((10 == this.state.selectedIntervension.Id)) {
                    formValue = candidacyFormRef.current.getValue();
                }
                if (!utils.isNull(formValue)) {
                    formValue.programmeType = this.state.selectedIntervension.Id;
                    this.props.stepHandler(3, true, formValue);
                }
            }
            else {
                formValue = {};
                this.props.stepHandler(3, true, formValue);
            }
        }
    }

    render() {
        return (
            <div style={{ paddingTop: "0 !important", paddingLeft: "32px", height: "100%"}}>
                {
                    !utils.isStringEmpty(this.props.saveMessage) ?
                        <p className={this.props.hasSaveError ? "errorMessage" : "message"}>
                            {this.props.saveMessage}
                        </p>
                        :
                        ""
                }
                <EntityForm viewId="learnerProgramIntervension" values={this.state.formValue} useCustomSettings={false} valueChangeHandler={(values) => { this.handleProgrammeFormValueChange(values); }}>
                    {form =>
                        <form className={form.classes.container} id="learnerProgramIntervensionForm">
                            <div className="row w-50">
                                <div className="col w-100">
                                    <SelectItem
                                        dataUrl="api/sims/learner/GetLearnerInterventionsByRole"
                                        id="Intervension"
                                        label="Programme Type"
                                        className="{classes.select} w-100"
                                        form={form} />
                                </div>
                            </div>
                        </form>
                    }
                </EntityForm>
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 1 ?
                    <div style={{
                        margin: "8px 0 16px 8px",
                        height: "38%",
                        //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 1 ? 'block' : 'none'
                    }}>
                        <p className="legend">
                            Enroll to a Learnership
                            </p>
                        <div style={{ height: "100%"}}>
                            <LearnerLearnershipForm data={this.props.data} hideFields={true} ref={learnershipFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                        </div>
                    </div>
                    :
                    ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 2 ?
                    <div style={{
                        margin: "8px 0 16px 8px",
                        height: "38%",
                        //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 2 ? 'block' : 'none'
                    }}>
                        <p className="legend">
                            Enroll to a Skills Programme
                            </p>
                        <div style={{ height: "90%", overflow: "auto" }}>
                            <LearnerSkillsProgramForm  data={this.props.data} hideFields={true} ref={skillsProgramFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                        </div>
                    </div>
                    :
                    ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 3 ?
                    <div style={{
                        margin: "8px 0 16px 8px",
                        height: "38%",
                        //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 3 ? 'block' : 'none'
                    }}>
                        <p className="legend">
                            Enroll to a Unit Standard
                            </p>
                        <div style={{ height: "90%", overflow: "auto" }}>
                            <LearnerUnitStandardForm data={this.props.data} hideFields={true} ref={unitStandardFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                        </div>
                    </div>
                    :
                    ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 4 ?
                    <div style={{
                        margin: "8px 0 16px 8px",
                        height: "38%",
                        //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                    }}>
                        <p className="legend">
                            Enroll to a Qualification
                            </p>
                        <div style={{ height: "90%", overflow: "auto" }}>
                            <LearnerQualificationForm data={this.props.data} hideFields={true} ref={qualificationFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                        </div>
                    </div>
                    :
                    ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 5 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to a Trade
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerTradeForm data={this.props.data} hideFields={true} ref={tradeFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 6 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to a Internship
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerInternshipForm data={this.props.data} hideFields={true} ref={internshipFormRef} valueChangeHandler={(values) => { this.handleInternshipFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 7 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to a Bursary
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerBursaryForm data={this.props.data} hideFields={true} dependency={this.state.dependency} ref={bursaryFormRef} valueChangeHandler={(values) => { this.handleBursaryFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 8 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to an AET
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerAETForm data={this.props.data} hideFields={true} ref={aetFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 9 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to an TVET Placement
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerFETForm data={this.props.data} hideFields={true} ref={fetFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                {
                    !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id == 10 ?
                        <div style={{
                            margin: "8px 0 16px 8px",
                            height: "38%",
                            //display: !utils.isNull(this.state.selectedIntervension) && this.state.selectedIntervension.Id === 4 ? 'block' : 'none'
                        }}>
                            <p className="legend">
                                Enroll to a Candidacy Programme
                            </p>
                            <div style={{ height: "90%", overflow: "auto" }}>
                                <LearnerCandidacyForm data={this.props.data} hideFields={true} ref={candidacyFormRef} valueChangeHandler={(values) => { this.handleFormValueChange(values) }} />
                            </div>
                        </div>
                        :
                        ""
                }
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td width="90%">
                                    </td>
                                    <td width="20%" align="right">
                                        <div style={{ width: "120px", marginTop: "16px" }}>
                                            <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)} config={toolbarConfig} />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
            </div>
        );
    }
}

export default withRouter(
    connect()(AddLearnerProgram)
);
